import { useEffect } from 'react';

const SEARCH_QUERY_KEY = 'query';

export const useQuery = (setInputValue: (text: string) => void, withInputFilled: boolean) => {
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchQuery = params.get(SEARCH_QUERY_KEY);
    if (searchQuery) {
      setInputValue(withInputFilled ? searchQuery : '');
    }
  }, [withInputFilled]);
};
